import {
  PageInformationContent,
  PageInformationList,
  PageInformationDivider,
  IPageInformationListProps,
} from '@reapitform/dashboard-ui'
import React from 'react'

const PrivacyAndSecurityInformationSection: React.FC<Omit<IPageInformationListProps, 'tag' | 'children'>> = (props) => {
  return (
    <PageInformationList tag="section" {...props}>
      <PageInformationContent
        iconName="glasses-invisible"
        title="What others can see"
        description="Your personal information is visible to everyone. These details will be applied to all forms created by you."
      />
      <PageInformationDivider />
      <PageInformationContent
        iconName="lock"
        title="Securing your account"
        description="Your login details are managed through Reapit Connect. We’ve kept them hidden here for your privacy."
      />
    </PageInformationList>
  )
}

export default PrivacyAndSecurityInformationSection
